<template>
    <modal-frame 
      :isVisible="props.isVisible" 
      :width="props.width" 
      :hegiht="props.height" 
      :maxWidth="props.maxWidth"
      :isOverlay="props.isOverlay"
      customClass="alert_wrap"
      @closeDialogHandler="emit('closeDialogHandler',0)">
        <div class="modal_title alert_title">
            <h4>{{ props.title || $t('trading.common.alert') }}</h4>
        </div>
        <div class="modal_body alert_body">
            <p v-html="props.content"></p>
        </div>
        <div class="col-12 text-center modal_btn">
            <button type="button" class="btn btn-primary mlr-5" @click="emit('closeDialogHandler',1)">{{$t('trading.common.confirm')}}</button>
            <button type="reset" class="btn btn-secondary mlr-5" @click="emit('closeDialogHandler',0)">{{$t('trading.table.cancel')}}</button>
        </div>
    </modal-frame>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import ModalFrame from './ModalFrame.vue';
const emit = defineEmits(['closeDialogHandler']);
const props = defineProps({
    isVisible: { type: Boolean },
    title: { type: String },
    content: { type: String },
    width: { type: String },
    height: { type: String },
    maxWidth: { type: String },
    isOverlay: {
        type: Boolean,
        default: true,
    },
});


</script>

<style lang="scss" scoped>
.alert_body p{ text-align: center;}
</style>